import React, { useEffect } from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";

// @mui/material components
import { Dialog, DialogActions, DialogTitle, DialogContent, DialogContentText } from "@mui/material";

// core components
import Button from "components/button/button";
import Loader from '../../configuration/components/loader';

// actions
import { deleteGender } from "actions/gender/delete";

function DeleteDialog(props) {
    const { gender, closeDialog, deleted, loading, isOpen } = props;

    const isSubGender = Boolean(gender && gender.parent !== null);

    useEffect(() => {
        if (deleted) {
            closeDialog();
        }
    }, [deleted]);

    return (
        <Dialog
            open={isOpen}
            onClose={closeDialog}
            maxWidth={'xs'}
            scroll={'body'}
        >
            <DialogTitle>
                <FormattedMessage
                    id={isSubGender ? "gender.delete.sub.title" : "gender.delete.title"}
                    values={{ gender: gender.name }}
                />
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <FormattedMessage id={"gender.delete.text"} />
                </DialogContentText>
            </DialogContent>
                <DialogActions>
                    <Button color={"info"} simple onClick={closeDialog} disabled={loading}>
                        <FormattedMessage id={"gender.delete.cancel"} />
                    </Button>
                    <Button
                        round
                        color={"danger"}
                        type="submit"
                        disabled={loading}
                        onClick={() => props.deleteGender(gender)}
                    >
                        <FormattedMessage id={"gender.delete.submit"} />
                        {loading && <Loader />}
                    </Button>
                </DialogActions>
        </Dialog>
    )
}

const mapStateToProps = state => {
    return {
        loading: state.gender.deleteGender.loading,
        deleted: state.gender.deleteGender.deleted,
    }
};

const mapDispatchToProps = dispatch => ({
    deleteGender: (item) => dispatch(deleteGender(item)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DeleteDialog);
